/* =====================================================
   EZMA OUD — Theme JavaScript  v3.0
   ===================================================== */

'use strict';

/* ─────────────────────────────────────────────────────
   SHIMMER KEYFRAMES  (inject once)
   ───────────────────────────────────────────────────── */
(function injectShimmerCSS() {
  if (document.getElementById('ezma-shimmer-css')) return;
  const s = document.createElement('style');
  s.id = 'ezma-shimmer-css';
  s.textContent = '@keyframes shimmer { from { background-position: 0 center; } to { background-position: 200% center; } }';
  document.head.appendChild(s);
})();

/* ─────────────────────────────────────────────────────
   NAMED INIT FUNCTIONS — re-callable by editor events
   ───────────────────────────────────────────────────── */

function initHeaderScroll() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  if (header._scrollHandler) window.removeEventListener('scroll', header._scrollHandler);
  header._scrollHandler = () => header.classList.toggle('scrolled', window.scrollY > 60);
  window.addEventListener('scroll', header._scrollHandler, { passive: true });
  header._scrollHandler();
}

function initMobileNav() {
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileOverlay = document.querySelector('.mobile-nav-overlay');
  const mobileClose = document.querySelector('.mobile-nav-close');
  if (!hamburger || hamburger._navBound) return;
  hamburger._navBound = true;
  const openNav  = () => { mobileNav?.classList.add('open'); mobileOverlay?.classList.add('open'); document.body.classList.add('drawer-open'); };
  const closeNav = () => { mobileNav?.classList.remove('open'); mobileOverlay?.classList.remove('open'); document.body.classList.remove('drawer-open'); };
  hamburger.addEventListener('click', openNav);
  mobileClose?.addEventListener('click', closeNav);
  mobileOverlay?.addEventListener('click', closeNav);
}

function init3DTilt(scope) {
  if (window.innerWidth < 768 || window.Shopify?.designMode) return;
  const root  = scope instanceof Element ? scope : document;
  const cards = root.querySelectorAll('.product-card:not([data-tilt-bound]), .collection-card:not([data-tilt-bound]), .testimonial-card:not([data-tilt-bound])');
  cards.forEach(card => {
    card.setAttribute('data-tilt-bound', '1');
    card.addEventListener('mousemove', (e) => {
      const r  = card.getBoundingClientRect();
      const rx = ((e.clientY - r.top  - r.height / 2) / (r.height / 2)) * -6;
      const ry = ((e.clientX - r.left - r.width  / 2) / (r.width  / 2)) *  6;
      card.style.transform = `perspective(800px) rotateX(${rx}deg) rotateY(${ry}deg) translateZ(10px)`;
    });
    card.addEventListener('mouseleave', () => {
      card.style.transition = 'all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      card.style.transform  = '';
      setTimeout(() => { card.style.transition = ''; }, 500);
    });
    card.addEventListener('mouseenter', () => { card.style.transition = 'none'; });
  });
}

function initHeroParallax() {
  const heroBg = document.querySelector('.hero-bg img');
  if (!heroBg || window.innerWidth < 768 || window.Shopify?.designMode) return;
  if (heroBg._parallaxBound) return;
  heroBg._parallaxBound = true;
  window.addEventListener('scroll', () => {
    heroBg.style.transform = `scale(1.1) translateY(${window.scrollY * 0.3}px)`;
  }, { passive: true });
}

async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  } catch (e) {}
}

function initAddToCart(scope) {
  const root = scope instanceof Element ? scope : document;
  root.querySelectorAll('[data-add-to-cart]:not([data-cart-bound])').forEach(btn => {
    btn.setAttribute('data-cart-bound', '1');
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      const variantId   = this.dataset.variantId;
      const qty         = parseInt(this.dataset.quantity || 1);
      if (!variantId) return;
      const originalHTML = this.innerHTML;
      this.innerHTML = '<span class="loading-dots">Adding</span>';
      this.disabled  = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });
        if (res.ok) {
          await updateCartCount();
          this.innerHTML = '✓ Added!';
          setTimeout(() => {
            this.innerHTML = originalHTML;
            this.disabled  = false;
            document.getElementById('cart-drawer')?.classList.add('open');
            document.body.classList.add('drawer-open');
          }, 1500);
        } else { throw new Error('Could not add item'); }
      } catch (err) {
        this.innerHTML = 'Try again';
        this.disabled  = false;
        console.error(err);
      }
    });
  });
}

function initGallery(scope) {
  const root    = scope instanceof Element ? scope : document;
  const thumbs  = root.querySelectorAll('.product-thumb:not([data-gallery-bound])');
  const mainImg = document.querySelector('.product-main-image img');
  if (!thumbs.length || !mainImg) return;
  thumbs.forEach(thumb => {
    thumb.setAttribute('data-gallery-bound', '1');
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const newSrc = this.querySelector('img')?.src;
      if (newSrc) {
        mainImg.style.opacity = '0'; mainImg.style.transform = 'scale(0.97)';
        mainImg.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        setTimeout(() => { mainImg.src = newSrc; mainImg.style.opacity = '1'; mainImg.style.transform = 'scale(1)'; }, 250);
      }
    });
  });
}

function initQuantitySelector(scope) {
  const root = scope instanceof Element ? scope : document;
  root.querySelectorAll('.qty-selector:not([data-qty-bound])').forEach(sel => {
    sel.setAttribute('data-qty-bound', '1');
    const input = sel.querySelector('input');
    if (!input) return;
    sel.querySelector('[data-qty-minus]')?.addEventListener('click', () => { if (parseInt(input.value) > 1) input.value = parseInt(input.value) - 1; });
    sel.querySelector('[data-qty-plus]')?.addEventListener('click',  () => { input.value = parseInt(input.value) + 1; });
  });
}

function initNewsletter() {
  const form = document.querySelector('.newsletter-form');
  if (!form || form.dataset.newsletterBound) return;
  form.dataset.newsletterBound = '1';
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = form.querySelector('input[type="email"]').value;
    const btn   = form.querySelector('button');
    if (!email) return;
    const orig = btn.innerHTML;
    btn.innerHTML = 'Subscribing...'; btn.disabled = true;
    setTimeout(() => {
      btn.innerHTML = '✓ Subscribed!'; form.querySelector('input').value = '';
      setTimeout(() => { btn.innerHTML = orig; btn.disabled = false; }, 3000);
    }, 1200);
  });
}

function initScrollReveal(scope) {
  const root = scope instanceof Element ? scope : document;
  const els  = root.querySelectorAll(
    '.scroll-reveal:not(.animate-in), .scroll-reveal-left:not(.animate-in), .scroll-reveal-right:not(.animate-in), .scroll-reveal-scale:not(.animate-in)'
  );
  if (!els.length) return;

  // In design mode, reveal everything immediately so editors can see content
  if (window.Shopify?.designMode) {
    els.forEach(el => el.classList.add('animate-in'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('animate-in'); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  els.forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) el.classList.add('animate-in');
    else observer.observe(el);
  });
}

function initLogoShimmer() {
  document.querySelectorAll('.header-logo-text, .loader-logo, .footer-logo').forEach(logo => {
    if (logo.dataset.shimmerBound) return;
    logo.dataset.shimmerBound = '1';
    logo.style.backgroundImage = 'linear-gradient(90deg, #C9A84C, #E4C86A, #C9A84C, #8B6914)';
    logo.style.backgroundSize  = '200% auto';
    logo.style.webkitBackgroundClip = 'text';
    logo.style.webkitTextFillColor  = 'transparent';
    logo.style.backgroundClip = 'text';
    logo.style.animation      = 'shimmer 4s linear infinite';
  });
}

function initCollectionFilter() {
  document.querySelectorAll('.filter-btn:not([data-filter-bound])').forEach(btn => {
    btn.setAttribute('data-filter-bound', '1');
    btn.addEventListener('click', function () {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });
}

function initVariantButtons() {
  document.querySelectorAll('.option-btn:not([data-variant-bound])').forEach(btn => {
    btn.setAttribute('data-variant-bound', '1');
    btn.addEventListener('click', function () {
      this.closest('.option-buttons')?.querySelectorAll('.option-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });
}

function initHeroAnimations() {
  if (window.Shopify?.designMode) return; // skip in editor so hero is always visible
  const heroEls = document.querySelectorAll('.hero-badge, .hero-title, .hero-title-arabic, .hero-desc, .hero-actions');
  heroEls.forEach((el, i) => {
    el.style.opacity   = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = `opacity 0.8s ease ${0.4 + i * 0.15}s, transform 0.8s cubic-bezier(0.25,0.46,0.45,0.94) ${0.4 + i * 0.15}s`;
  });
  setTimeout(() => {
    heroEls.forEach(el => { el.style.opacity = '1'; el.style.transform = 'none'; });
  }, 1900);
}

function initCursorGlow() {
  const cursor = document.getElementById('cursorGlow');
  if (!cursor || window.innerWidth <= 768) return;
  document.addEventListener('mousemove', (e) => {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top  = e.clientY + 'px';
  });
}

function initCartDrawer() {
  document.querySelectorAll('[data-cart-open]:not([data-drawer-bound])').forEach(btn => {
    btn.setAttribute('data-drawer-bound', '1');
    btn.addEventListener('click', () => { document.getElementById('cart-drawer')?.classList.add('open'); document.body.classList.add('drawer-open'); });
  });
  const cartClose = document.getElementById('cartClose');
  if (cartClose && !cartClose.dataset.bound) {
    cartClose.dataset.bound = '1';
    cartClose.addEventListener('click', () => { document.getElementById('cart-drawer')?.classList.remove('open'); document.body.classList.remove('drawer-open'); });
  }
  const overlay = document.querySelector('.cart-drawer__overlay');
  if (overlay && !overlay.dataset.bound) {
    overlay.dataset.bound = '1';
    overlay.addEventListener('click', () => { document.getElementById('cart-drawer')?.classList.remove('open'); document.body.classList.remove('drawer-open'); });
  }
}

function initWishlist(scope) {
  const root = scope instanceof Element ? scope : document;
  const btns = root.querySelectorAll('[data-wishlist-btn]:not([data-wishlist-bound])');
  
  const getWishlist = () => JSON.parse(localStorage.getItem('ezma_wishlist') || '[]');
  const saveWishlist = (list) => localStorage.setItem('ezma_wishlist', JSON.stringify(list));
  
  const updateUI = () => {
    const list = getWishlist();
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const isAdded = list.includes(btn.dataset.handle);
      btn.classList.toggle('active', isAdded);
      const svg = btn.querySelector('svg');
      if (svg) {
        svg.setAttribute('fill', isAdded ? 'currentColor' : 'none');
      }
    });
  };

  btns.forEach(btn => {
    btn.setAttribute('data-wishlist-bound', '1');
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const handle = this.dataset.handle;
      if (!handle) return;
      
      let list = getWishlist();
      if (list.includes(handle)) {
        list = list.filter(h => h !== handle);
      } else {
        list.push(handle);
      }
      saveWishlist(list);
      updateUI();
      
      // Optional: Show a small toast or feedback
      console.log('Wishlist updated:', list);
    });
  });
  
  updateUI();
}

/* ─────────────────────────────────────────────────────
   MASTER INIT
   ───────────────────────────────────────────────────── */
function initAll(scope) {
  initHeaderScroll();
  initMobileNav();
  init3DTilt(scope);
  initHeroParallax();
  initAddToCart(scope);
  initGallery(scope);
  initQuantitySelector(scope);
  initNewsletter();
  initScrollReveal(scope);
  initLogoShimmer();
  initCollectionFilter();
  initVariantButtons();
  initCursorGlow();
  initCartDrawer();
  initWishlist(scope);
}

/* ─────────────────────────────────────────────────────
   DOM READY
   ───────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  // Page Loader
  const loader = document.getElementById('page-loader');
  if (loader) setTimeout(() => loader.classList.add('loaded'), window.Shopify?.designMode ? 200 : 1800);

  initHeroAnimations();
  initAll();
});

/* ─────────────────────────────────────────────────────
   ✅ SHOPIFY THEME EDITOR EVENTS
   Makes changes appear INSTANTLY — no refresh needed
   ───────────────────────────────────────────────────── */

// Triggered when a section's settings change OR a new section is added
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  // Reveal scroll-reveal elements immediately in editor
  section.querySelectorAll('.scroll-reveal, .scroll-reveal-left, .scroll-reveal-right, .scroll-reveal-scale').forEach(el => {
    el.classList.add('animate-in');
  });
  // Re-init all features for the updated section
  initAll(section);
  initLogoShimmer();
  // If hero section reloaded, show content immediately
  if (section.querySelector('.hero-bg, .hero-title')) {
    section.querySelectorAll('.hero-badge, .hero-title, .hero-title-arabic, .hero-desc, .hero-actions').forEach(el => {
      el.style.transition = 'none';
      el.style.opacity    = '1';
      el.style.transform  = 'none';
    });
  }
});

// Triggered when a block's settings change
document.addEventListener('shopify:block:load', (event) => {
  const section = event.target.closest('[data-shopify-editor-section]') || document;
  section.querySelectorAll('.scroll-reveal, .scroll-reveal-left, .scroll-reveal-right, .scroll-reveal-scale').forEach(el => el.classList.add('animate-in'));
  init3DTilt(section);
  initScrollReveal(section);
});

// User clicks a section in the editor sidebar — reveal it
document.addEventListener('shopify:section:select', (event) => {
  event.target.querySelectorAll('.scroll-reveal, .scroll-reveal-left, .scroll-reveal-right, .scroll-reveal-scale').forEach(el => el.classList.add('animate-in'));
});

// User clicks a block in the editor sidebar
document.addEventListener('shopify:block:select', (event) => {
  event.target.querySelectorAll('.scroll-reveal, .scroll-reveal-left, .scroll-reveal-right').forEach(el => el.classList.add('animate-in'));
  event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
});
